import {Component, EventEmitter, Output, ChangeDetectionStrategy} from '@angular/core';
import {saveAs} from 'file-saver';
import {MessageLevel, PgMessagesService} from '../../../../../shared/services/pg-messages.service';
import {DocumentService} from '../../../../../documents/documents.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { AuthenticationModule } from 'src/app/authentication/authentication.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { CrewChange, Crew } from 'src/app/generated/services/transportation/crew/crew';

@Component({
  selector: 'app-crew-change-toolbar',
  templateUrl: './crew-change-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[SharedModule, AuthenticationModule, MatMenuModule, MatIconModule, MatButtonModule]
})
export class CrewChangeToolbarComponent {

  private _crewChange = CrewChange.create();
  private _crew = Crew.create();

  public get crewChange() {
    return this._crewChange;
  }
  public set crewChange(value: CrewChange) {
    this._crewChange = value;
  }

  public get crew() {
    return this._crew;
  }

  public set crew(value: Crew) {
    this._crew = value;
  }

  @Output() cancelPlan = new EventEmitter<void>();
  @Output() deleteCrewChange = new EventEmitter<void>();
  @Output() newContractExtension = new EventEmitter<void>();

  constructor(private _documentService: DocumentService,
              private _messagesService: PgMessagesService) { }

  downloadContract() {
    if (this.crewChange.contract) {
      this._documentService.download(this.crewChange.contract.contractDocumentId).subscribe(b => {
        saveAs(b.body, `${this.crew.firstName}-${this.crew.lastName}-contract.pdf`);
      }, () => {
        this._messagesService.publishMessage({
          message: 'Could not download this file.',
          level: MessageLevel.Error,
          topic: 'Crew contract'
        });
      });
    }
  }

  cancelAll() {
    if (confirm('Are you sure you want to cancel the assignment')) {
      this.cancelPlan.emit();
    }
  }

  delete() {
    if (confirm('Are you sure you want to delete this crew change?')) {
      this.deleteCrewChange.emit();
    }
  }

  addContractExtension() {
    this.newContractExtension.emit();
  }
}
